type ScoringEvent = {
  playerId: string;
  createdAt: string;
  gameEvent: {
    points: number;
  };
};

type Pick = {
  playerId: string;
  createdAt: string;
  powerupPoints: number;
};

export type ScoreByPlayer = Record<
  string,
  {
    missed: {
      base: number;
      powerup: number;
      total: number;
    };
    earned: {
      base: number;
      powerup: number;
      total: number;
    };
  }
>;

export function getScoreByPlayer(
  scoringEvents: ScoringEvent[],
  picks: Pick[],
): ScoreByPlayer {
  const scoreByPlayer: ScoreByPlayer = {};

  for (const pick of picks) {
    const playerId = pick.playerId;
    const pickCreatedAt = new Date(pick.createdAt);

    const playerEvents = getEventsForPlayer(playerId, scoringEvents);
    const { beforePick, afterPick } = partitionEventsByPickTime(
      playerEvents,
      pickCreatedAt,
    );

    const missedPoints = calculatePoints(beforePick, pick);
    const earnedPoints = calculatePoints(afterPick, pick);

    scoreByPlayer[playerId] = {
      missed: missedPoints,
      earned: earnedPoints,
    };
  }

  return scoreByPlayer;
}

function getEventsForPlayer(playerId: string, scoringEvents: ScoringEvent[]) {
  return scoringEvents.filter((event) => event.playerId === playerId);
}

function partitionEventsByPickTime(
  events: ScoringEvent[],
  pickCreatedAt: Date,
) {
  const beforePick: ScoringEvent[] = [];
  const afterPick: ScoringEvent[] = [];

  for (const event of events) {
    const eventCreatedAt = new Date(event.createdAt);

    if (eventCreatedAt < pickCreatedAt) {
      beforePick.push(event);
    } else {
      afterPick.push(event);
    }
  }

  return { beforePick, afterPick };
}

function calculatePoints(events: ScoringEvent[], pick: Pick) {
  let basePoints = 0;
  let powerupPoints = 0;

  for (const event of events) {
    basePoints += event.gameEvent.points;
    powerupPoints += pick.powerupPoints;
  }

  const totalPoints = basePoints + powerupPoints;

  return {
    base: basePoints,
    powerup: powerupPoints,
    total: totalPoints,
  };
}
